import type { FlowAnswers } from "@/shared/constants/flowTypes";

export function filterAnswersForTask(
  allAnswers: FlowAnswers,
  taskId: string,
  answerTaskMap: Record<string, string>,
): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(allAnswers)) {
    if (answerTaskMap[key] !== taskId) continue;
    if (value === undefined) continue;
    out[key] = value;
  }
  return out;
}
